"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KilledEventArgs = void 0;
const EventType_1 = require("../EventType");
class KilledEventArgs {
    constructor(killer) {
        this.killer = killer;
        this.__type = EventType_1.EventType.Killed;
        this.__typeName = "Killed";
    }
}
exports.KilledEventArgs = KilledEventArgs;
